// extracted by mini-css-extract-plugin
module.exports = {"full":"Texte_full__1itQ7","left":"Texte_left__2yFI1","right":"Texte_right__H4UFl"};